import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './styles.css';
import { ToastProvider } from './ui';
import { getToken, getUser } from './api';
import { Layout } from './Layout';
import { ErrorBoundary } from './ErrorBoundary';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import ProductCard from './pages/ProductCard';
import CustomsGroups from './pages/CustomsGroups';
import Categories from './pages/Categories';
import Suppliers from './pages/Suppliers';
import Orders from './pages/Orders';
import OrderEdit from './pages/OrderEdit';
import Receipts from './pages/Receipts';
import Shortages from './pages/Shortages';
import Customs from './pages/Customs';
import CustomsEdit from './pages/CustomsEdit';
import Prices from './pages/Prices';
import PriceHistory from './pages/PriceHistory';
import PrixodMatrix from './pages/PrixodMatrix';
import Contract from './pages/Contract';
import Currencies from './pages/Currencies';
import Reports from './pages/Reports';
import Payments from './pages/Payments';
import Accounting from './pages/Accounting';
import Audit from './pages/Audit';
import Users from './pages/Users';

function Private({ children }: { children: React.ReactNode }) {
  return getToken() ? <>{children}</> : <Navigate to="/login" replace />;
}

/**
 * Bosh sahifa rolga qarab.
 *
 * `buxgalter` uchun boshqaruv paneli yopiq (`/dashboard` unga ruxsat bermaydi),
 * shuning uchun kirgan zahoti o'z bo'limiga tushadi — aks holda kirishi bilan
 * xato ko'rardi.
 */
function Home() {
  const user = getUser();
  if (user?.role === 'buxgalter') return <Navigate to="/accounting" replace />;
  return <Dashboard />;
}


/** Noto'g'ri manzil — oq sahifa o'rniga tushunarli xabar. */
function NotFound() {
  return (
    <div className="empty">
      <div className="e-title">Sahifa topilmadi</div>
      <div style={{ marginBottom: 14 }}>Manzil noto'g'ri yoki bo'lim o'chirilgan.</div>
      <a className="btn btn-primary" href="/">Bosh sahifaga</a>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Private><Layout /></Private>}>
          <Route index element={<Home />} />
          <Route path="products" element={<Products />} />
          <Route path="products/:id" element={<ProductCard />} />
          <Route path="customs-groups" element={<CustomsGroups />} />
          <Route path="categories" element={<Categories />} />
          <Route path="suppliers" element={<Suppliers />} />
          <Route path="orders" element={<Orders />} />
          <Route path="orders/:id" element={<OrderEdit />} />
          <Route path="receipts" element={<Receipts />} />
          <Route path="shortages" element={<Shortages />} />
          <Route path="customs" element={<Customs />} />
          <Route path="customs/:id" element={<CustomsEdit />} />
          <Route path="prices" element={<Prices />} />
          <Route path="price-history" element={<PriceHistory />} />
          <Route path="prixod-matrix" element={<PrixodMatrix />} />
          <Route path="contract" element={<Contract />} />
          <Route path="currencies" element={<Currencies />} />
          <Route path="reports" element={<Reports />} />
          <Route path="payments" element={<Payments />} />
          <Route path="accounting" element={<Accounting />} />
          <Route path="audit" element={<Audit />} />
          <Route path="users" element={<Users />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

// Tema (dark/light) — birinchi renderdan oldin qo'llanadi
document.documentElement.setAttribute('data-theme', localStorage.getItem('alight_theme') || 'dark');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary full>
      <ToastProvider>
        <App />
      </ToastProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
